import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../common/url';
import { AppToast } from '../../lib/toast';
import { getAuthURL } from '../../services/msalAuthService'
import { authTokenKey, setUserAuth } from '../../store/auth/authSlice';
import { SignInTemplate } from './signInTemplate'
import { useDispatch } from "react-redux";
import { AppLocalStorage } from '../../helpers/localStorageHelper';


export function SignIn(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (location.state && location.state.unAuthorized) {
            AppToast.Toast.error({ title: 'Error', message: "Unauthorized access. please contact your administrator.", delayInMs: 4000 })
            navigate(location.pathname, { replace: true })
        }
        else if (location?.state?.noPermission) {
            AppToast.Toast.error({ title: 'Error', message: 'Kindly check with administrator to assign active roles.', delayInMs: 4000 })
            navigate(location.pathname, { replace: true })
        }

    }, [])

    function signIn() {

        Promise.all([
            dispatch(setUserAuth({})),
            dispatch(authTokenKey())
        ]).then(([userAuthres,res]) => {
            if (res.payload.data?.enableAuthKey) {
                AppLocalStorage.setStorageItem("authKey", res.payload.data.authEncKey)
                AppLocalStorage.setStorageItem("enableAuthKey", res.payload.data.enableAuthKey)
                AppLocalStorage.setStorageItem("tokenValidityInMin", res.payload.data.tokenValidityInMin)
            }
            const url = `${API_BASE_URL}/auth`;
            getAuthURL(url).then((res) => {
                if (res.status === 200)
                    window.location.href = res.data;
            })
        }).catch((error) => {
            //console.log(error)
        }) 
        // dispatch(setUserAuth({}))

        // const url = `${API_BASE_URL}/auth`;
        // getAuthURL(url).then((res) => {
        //     if (res.status === 200)
        //         window.location.href = res.data;
        // })
    }
    return <SignInTemplate signIn={signIn} />
}